import Locale from './locale';

import Data from './index';
import { formatRBF } from 'logic/itemDescription';
import { GameVersion, getAssetsPath, HasPTR } from 'common';
import { initPresets } from 'logic/itemTypes';
//import * as Logic from './logic';

//import { addActive } from './actives';

//Object.assign(Data, Logic);

function filterRows(table, func) {
  const result = {};
  for (const id in table) {
    if (func(table[id])) result[id] = table[id];
  }
  return result;
}

function processData(Data, rawData, locale, animBuf) {
  Object.assign(Data, rawData);

  Data.localeTable = {};//...locale.localeTable};

  const strings = {};
  const istrings = [];
  const stringi = {};
  for (let index = 9999; index >= 0; --index) {
    const entry = locale[index]
    if (entry) {
      istrings[index] = entry[1];
      strings[entry[0]] = entry[1];
      stringi[entry[0]] = index;
    }
  }
  for (let index = locale.length - 1; index >= 20000; --index) {
    const entry = locale[index]
    if (entry) {
      istrings[index] = entry[1];
      strings[entry[0]] = entry[1];
      stringi[entry[0]] = index;
    }
  }
  for (let index = 19999; index >= 10000; --index) {
    const entry = locale[index]
    if (entry) {
      istrings[index] = entry[1];
      strings[entry[0]] = entry[1];
      stringi[entry[0]] = index;
    }
  }
  Locale.strings = strings;
  Locale.istrings = istrings;
  Locale.stringi = stringi;

  const statList = [];
  for (const id in Data.itemStatCost) {
    const stat = Data.itemStatCost[id];
    let priority = (stat.descpriority || 0) + stat.id * 0.001;
    if (id === 'item_magicbonus' || id === 'passive_cold_mastery' || id === 'passive_pois_mastery') {
      // why is it in different order?
      // Gheed has MF% before vendor%
      // Grief has mana/kill before life/kill (reverse order)
      // Ormus has elemental bonuses in reverse order
      priority += 0.1;
    } else if (id === 'item_preventheal' || id === 'item_replenish_durability') {
      // Call to Arms has PMH after single skill bonuses
      priority -= 0.1;
    }
    statList.push([id, priority]);
  }
  statList.sort((a, b) => a[1] - b[1]);
  statList.forEach(([id], i) => Data.itemStatCost[id].descpriority = i);

  Data.staffMods = {};
  const staffILvl = {1: 1, 6: 1, 12: 12, 18: 19, 24: 25, 30: 37};
  for (const id in Data.skills) {
    const skill = Data.skills[id];
    if (!skill.charclass || !staffILvl[skill.reqlevel]) continue;
    // charclass reqlevel
    const mod = Data.staffMods[`staff${id}`] = {
      version: (skill.reqlevel === 30 ? 100 : 1),
      rare: 1,
      level: staffILvl[skill.reqlevel],
      levelreq: skill.reqlevel,
      classspecific: skill.charclass,
      group: 600 + parseInt(id),
      tier: skill.reqlevel,
      multiply: skill.costmult,
      add: skill.costadd,

      mod1code: 'skill',
      mod1param: parseInt(id),
      mod1min: 1,
      mod1max: 3,
    };
    let itypes = 0;
    for (const id in Data.itemTypes) {
      const staff = Data.itemTypes[id].staffmods;
      if (staff === skill.charclass) {
        mod[`itype${++itypes}`] = id;
      }
    }
  }

  if (GameVersion < 100) {
    Data.armor = filterRows(Data.armor, row => row.version <= GameVersion);
    Data.misc = filterRows(Data.misc, row => row.version <= GameVersion);
    Data.weapons = filterRows(Data.weapons, row => row.version <= GameVersion);
    Data.uniqueItems = filterRows(Data.uniqueItems, row => row.version <= GameVersion);
    Data.sets = filterRows(Data.sets, row => row.version <= GameVersion);
    Data.setItems = filterRows(Data.setItems, row => Data.sets[row.set]);
    Data.autoMagic = filterRows(Data.autoMagic, row => row.version <= GameVersion);
    Data.crafted = {};
    Data.runes = {};
  }

  Data.magicPrefix = filterRows(Data.magicPrefix, row => row.version > 0 && row.version <= GameVersion);
  Data.magicSuffix = filterRows(Data.magicSuffix, row => row.version > 0 && row.version <= GameVersion);

  for (const id in Data.hireling) {
    const version = (GameVersion === 100 ? 100 : 0);
    Data.hireling[id] = Data.hireling[id].filter(row => row.version === version);
  }

  Data.items = Object.assign({}, Data.armor, Data.misc, Data.weapons);
  Data.mods = Object.assign({}, Data.autoMagic, Data.magicPrefix, Data.magicSuffix, Data.crafted, Data.qualityItems, Data.staffMods, Data.corruptedMods);

  for (const mod of Object.values(Data.mods)) {
    if ((mod.mod1code === 'sock' || mod.mod1code === 'rep-quant') && mod.mod1param && !mod.mod1min && !mod.mod1max) {
      mod.mod1min = mod.mod1param;
      mod.mod1max = mod.mod1param;
      delete mod.mod1param;
    }
  }

  Data.skillByName = {};
  for (const skill of Object.values(Data.skills)) {
    Data.skillByName[skill.skill.toLowerCase()] = skill;
  }
  Data.stateByName = {};
  for (const state of Object.values(Data.states)) {
    Data.stateByName[state.state.toLowerCase()] = state;
  }
  Data.missileByName = {};
  for (const missile of Object.values(Data.missiles)) {
    if (missile.srcdamage) {
      missile.srcdam = missile.srcdamage;
      delete missile.srcdamage;
    }
  
    Data.missileByName[missile.missile.toLowerCase()] = missile;
  }
  Data.monsterById = [];
  for (const monster of Object.values(Data.monsters)) {
    Data.monsterById[monster.hcidx] = monster;
    Object.assign(monster, Data.monstersEx[monster.monstatsex]);
  }

  //if (PTR) Data.skillDesc.eruption.dsc2calca3 = "miss('erruption center'.rang)";

  // flip min/max on '-X to Monster Defense Per Hit' stats
  function fixmod(row, prop, min, max) {
    if (row[prop] === 'sock') row.sockets = true;
    if (row[prop] === 'dmg-ac' && row[min] > row[max]) {
      const tmp = row[min];
      row[min] = row[max];
      row[max] = tmp;
    }
  }
  for (const row of Object.values(Data.mods)) {
    fixmod(row, 'mod1code', 'mod1min', 'mod1max');
    fixmod(row, 'mod2code', 'mod2min', 'mod2max');
    fixmod(row, 'mod3code', 'mod3min', 'mod3max');
    fixmod(row, 'mod4code', 'mod4min', 'mod4max');
    fixmod(row, 'mod5code', 'mod5min', 'mod5max');
  }
  for (const row of Object.values(Data.uniqueItems)) {
    for (let i = 1; i <= 12; ++i) {
      fixmod(row, `prop${i}`, `min${i}`, `max${i}`);
    }
  }
  for (const row of Object.values(Data.setItems)) {
    for (let i = 1; i <= 9; ++i) {
      fixmod(row, `prop${i}`, `min${i}`, `max${i}`);
    }
    for (let i = 1; i <= 5; ++i) {
      fixmod(row, `aprop${i}a`, `amin${i}a`, `amax${i}a`);
      fixmod(row, `aprop${i}b`, `amin${i}b`, `amax${i}b`);
    }
  }
  for (const row of Object.values(Data.sets)) {
    for (let i = 2; i <= 5; ++i) {
      fixmod(row, `pcode${i}a`, `pmin${i}a`, `pmax${i}a`);
      fixmod(row, `pcode${i}b`, `pmin${i}b`, `pmax${i}b`);
    }
    for (let i = 1; i <= 8; ++i) {
      fixmod(row, `fcode${i}`, `fmin${i}`, `fmax${i}`);
    }
  }

  // add value to increased stack size
  Data.itemStatCost.item_extra_stack.descfunc = 1;
  Data.itemStatCost.item_extra_stack.descval = 2;
  Data.itemStatCost.item_replenish_quantity.descfunc = 99;
  if (Data.info.legacyFormat) {
    Data.itemStatCost.item_pierce.descfunc = 2;
    Data.itemStatCost.item_pierce.descval = 2;
  }

  Locale.strings.ModStre9vx = `${Locale.strings.ModStre9vx} [1 in %d sec.]`;

  for (const [id, uniq] of Object.entries(Data.uniqueItems)) {
    if (uniq.code === 'jew') {
      uniq.suffix = formatRBF({unique: id});
    }
  }

  const anim32 = Data._animData = new Int32Array(animBuf);
  const anim8 = new Uint8Array(animBuf);
  let offset = 0;
  for (let i = 0; i < 256; ++i) {
    const count = anim32[offset++];
    for (let j = 0; j < count; ++j) {
      const code = String.fromCharCode(...anim8.subarray(offset * 4, offset * 4 + 7));
      Data._animIndex.set(code, offset + 2);
      const action = [];
      for (let k = 0; k < anim32[offset + 2]; ++k) {
        if (anim8[offset * 4 + 16 + k]) {
          action.push(k);
        }
      }
      anim32[offset + 4] = (action.length >= 1 ? action[0] : -1);
      anim32[offset + 5] = (action.length >= 2 ? action[1] : -1);
      offset += 40;
    }
  }

  initPresets();
}

function getFolders(version) {
  switch (version) {
  case 'pd2': return ['pd2/', 'pd2/'];
  case 'lod': return ['lod/', ''];
  case 'ptr': return ['ptr/', ''];
  case 'embed': return [HasPTR ? 'ptr/' : '', ''];
  default: return ['', ''];
  }
}

export default function loadData(version) {
  const [dataFolder, animFolder] = getFolders(version);

  const loadData = fetch(getAssetsPath(`${dataFolder}data.json`)).then(r => r.json());
  const loadLocale = fetch(getAssetsPath(`${dataFolder}strings.json`)).then(r => r.json());
  const loadAnim = fetch(getAssetsPath(`${animFolder}AnimData.D2`)).then(r => r.arrayBuffer());

  return Promise.all([loadData, loadLocale, loadAnim]).then(([rawData, rawLocale, animBuf]) => {
    processData(Data, rawData, rawLocale, animBuf);
    Data.loaded = true;
  });
}
